<template>
    <div class="modal fade" tabindex="-1" id="MetodoTrabalho">
        <div class="modal-dialog modal-fullscreen w-100">
            <div class="modal-content border-0">
                <div class="modal-body">
                    <div class="mt-3">
                        <h3 class="title">Método de trabalho.</h3>
                        <hr />
                        <div class="form">
                            <div class="row">
                                <div class="col-12">
                                    <iframe src="https://app.sollai.com.br/metodo-trabalho.pdf" width="100%" style="overflow: auto; padding: 0px; background-color: rgb(196, 196, 196); box-shadow: rgba(0, 0, 0, 0.25) 5px 0px 10px inset; height: calc(-8rem + 100vh); " />
                                </div>
                            </div>
                        </div>
                    </div>
                </div><!-- .modal-body -->
                <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-3 me-3" data-bs-dismiss="modal">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                    </svg><!-- x-lg -->
                </button><!-- modal-close -->
            </div><!-- .modal-content -->
        </div><!-- .modal-dialog -->
    </div><!-- .modal -->
</template>

<script>

    export default {
        name: 'MetodoTrabalho',
        data: function () {
            return {

            }
        },
        props: {
            showModal: Boolean,
        },
        methods: {
            load() {

            },

            close() {
                const myModalAlternative = new window.bootstrap.Modal('#MetodoTrabalho');
                myModalAlternative.hide();
            }

        },
        created: function () {
            this.load();
        },
        watch: {
            showModal: function () {
                const myModalAlternative = new window.bootstrap.Modal('#MetodoTrabalho');
                myModalAlternative.show();
            },

        }

    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /* Metodo trabalho */
    .form-control {
        border: 1px solid #474747;
    }

</style>

